export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11439.a53c63de.jpg";